import { useMemo } from "react";
import { useRoom } from "../pages/floor/RoomProvider";

/** useFloorMode — H3 · the room reorganizes around the moment.
 *   flow    — 95% of the day, calm
 *   focus   — a trip is selected, everything else fades
 *   incident — SOS or mass disruption, room dominates the incident
 */
export function useFloorMode() {
  const { focus, sosTripId } = useRoom();
  return useMemo(() => {
    if (sosTripId) return "incident";
    if (focus) return "focus";
    return "flow";
  }, [focus, sosTripId]);
}
